import React from "react";
import MovieDetailsBase from "@components/V3/MovieDetails/MovieDetailsBase";
import VersionedLayout from "@components/Wrappers/VersionedLayout/index.js";


const MovieDetailPage = () => {

    return (
        <VersionedLayout>
            <MovieDetailsBase />
        </VersionedLayout>
    );
};

export default MovieDetailPage;
